import React, { ReactNode } from "react";
import './DetailedList.scss';
import ErrorList from "./ErrorList";
import classNames from "classnames";

interface ConfirmationPageProps {
    errors?: string[];
}

const DetailedList: React.FC<ConfirmationPageProps> = React.memo(props => {
    return <div className="detailed-list">
        <table className="table table-striped">
            <tbody>
                {props.children}
            </tbody>
        </table>
        <ErrorList errors={props.errors}>
            <h3>Errors</h3>
        </ErrorList>
    </div>
});

interface DetailRowProps {
    label: ReactNode;
    value: ReactNode;
    highlight?: boolean;
    valueClassName?: string;
    'data-testid'?: string;
}

export const DetailRow: React.FC<DetailRowProps> = React.memo(props => {
    return <tr className={classNames("detail-row", { "highlight": props.highlight })} data-testid={props["data-testid"] ? `detail-row-${props["data-testid"]}` : undefined}>
        <td className="label" data-testid={props["data-testid"] ? `detail-row-${props["data-testid"]}` : undefined}>{props.label}</td>
        <td className={classNames("value", props.valueClassName)} data-testid={props["data-testid"] ? `detail-row-${props["data-testid"]}` : undefined}>{props.value}</td>
    </tr>;
})

export default DetailedList;